/* eslint-disable react/prop-types */
import React from 'react';
import { hooks as filterHooks } from '@src/containers/Filters';

import FitEvents from '..';

const PREVIEW_QTTY = 10;

const FitEventsCDefault = (props) => {
	const { events, onChangeValue, previewQtty = PREVIEW_QTTY } = props;
	const { setFilterValues } = filterHooks.useActions();
	const [isMoreOpened, setIsMoreOpened] = React.useState(false);

	const isMoreTextAvail = !isMoreOpened && events.length > previewQtty;

	const slicedEvents = React.useMemo(() => {
		return !isMoreTextAvail ? events : events.slice(0, previewQtty);
	}, [events, isMoreTextAvail, previewQtty]);

	const handleClickItem = React.useCallback(
		(item) => {
			if (item.id === -1) {
				return;
			}

			if (onChangeValue) {
				onChangeValue({ activeSpec: item.id });
			}
			setFilterValues({
				values: { event: [item.id === 0 ? 'reset' : item.id] },
				isPersistDate: true,
			});
		},
		[onChangeValue, setFilterValues],
	);

	const handleClickMore = React.useCallback(() => {
		setIsMoreOpened(true);
	}, []);

	const moreText = React.useMemo(() => {
		return `${t('Ещё')} ${events.length - previewQtty}`;
	}, [events.length, previewQtty]);

	return (
		<FitEvents
			items={slicedEvents}
			onClickItem={handleClickItem}
			moreText={isMoreTextAvail ? moreText : null}
			onClickMore={handleClickMore}
			{...props}
		/>
	);
};

export default FitEventsCDefault;
